import SideMenu from "../../components/organisms/SideMenu";
import { useEffect, useState } from "react";
import axios from "axios";
import api from "../../Api";
import { MdDeleteOutline } from "react-icons/md";
import AddPortfoliosPopUp from "../../components/organisms/portfolio/AddPortfoliosPopUp";
import { IoMdAdd } from "react-icons/io";

// Define an interface for portfolio items
interface PortfolioItem {
  _id: string;
  img: string;
}

export default function Portfolio() {
  const [portfolios, SetPortfolios] = useState<PortfolioItem[]>([]);
  const [isPopUpOpen, setIsPopUpOpen] = useState(false);

  // Function to fetch portfolios
  const fetchPortfolios = async () => {
    try {
      const response = await axios.get<{ images: PortfolioItem[] }>(
        api.portfolio,
        {
          headers: {
            api_key: api.key,
            authentication: api.authantication,
          },
        }
      );
      SetPortfolios(response.data.images);
    } catch (error) {
      console.error("Error fetching portfolios:", error);
    }
  };

  // Fetch portfolios on component mount
  useEffect(() => {
    fetchPortfolios();
  }, []);

  const handlePopUpClose = () => {
    setIsPopUpOpen(false);
  };

  const handleDeleteImage = async (id: string) => {
    try {
      await axios.delete(`${api.deleteAndAddImage}/${id}`, {
        headers: {
          api_key: api.key,
          authentication: api.authantication,
        },
      });

      SetPortfolios((prevPortfolios) =>
        prevPortfolios.filter((item) => item._id !== id)
      );
    } catch (error) {
      console.error("Error deleting image:", error);
    }
  };

  return (
    <div className="flex">
      <SideMenu />
      <div className="p-6 bg-background w-full space-y-6">
        <div className="flex items-center space-x-10">
          <div className="space-y-1">
            <h1 className="font-primary text-[32px]">Portfolio</h1>
            <p>Manage your portfolio shown on the website</p>
          </div>
        </div>

        <div className="grid grid-cols-5 gap-4">
          {portfolios.map((item, index) => (
            <div
              className="relative bg-black/[.05] rounded overflow-hidden group"
              key={index}
            >
              <MdDeleteOutline
                onClick={() => handleDeleteImage(item._id)}
                className="absolute top-2 right-2 group-hover:text-red-500 text-red-500/[.0] duration-300 cursor-pointer"
                size={24} // Adjust size as needed
              />
              <div className="flex items-center justify-center h-full">
                <img src={item.img} alt="Portfolio item" className="" />
              </div>
            </div>
          ))}
        </div>
      </div>
      <AddPortfoliosPopUp
        isPopUpOpen={isPopUpOpen}
        bigImage={true}
        onClose={handlePopUpClose}
        Title="Add Portfolios"
        SubTitle="Add images you want to add for the word of portfolio section"
        SubmitButtonText="Add a Image"
        onPortfolioUpdate={fetchPortfolios}
      />

      <div
        onClick={() => setIsPopUpOpen(true)}
        className="bg-primary w-[46px] h-fit hover:w-[140px] p-3 text-[22px] text-white rounded-full fixed right-4 bottom-4 group duration-300 flex items-center gap-2 cursor-pointer"
      >
        <IoMdAdd />
        <p className="text-[16px] hidden h-[24px] pr-2 group-hover:flex duration-300">
          Add Image
        </p>
      </div>
    </div>
  );
}
